"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var _clsx = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CommonTooltip = function CommonTooltip(props) {
  var toolTipMessage = props.toolTipMessage,
    timeout = props.timeout,
    isOpen = props.isOpen,
    delay = props.delay;
  var _useState = (0, _react.useState)(isOpen),
    visible = _useState[0],
    setVisible = _useState[1];
  var _useState2 = (0, _react.useState)(),
    timer = _useState2[0],
    setTimer = _useState2[1];
  var closeTooltip = function closeTooltip(e) {
    setVisible(false);
  };
  var startAutoCloseTimer = function startAutoCloseTimer() {
    var timerObj = setTimeout(function () {
      closeTooltip();
      setTimer(null);
      clearTimeout(timer);
    }, timeout);
    setTimer(timerObj);
  };
  (0, _react.useEffect)(function () {
    if (visible === true && timeout > 0) {
      startAutoCloseTimer();
    }
  }, [visible]);
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      setVisible(isOpen);
    }, delay);
  }, [isOpen]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_navigationHeader["default"].tooltipContainer, _navigationHeader["default"].desktop, visible ? _navigationHeader["default"].visible : '')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _navigationHeader["default"].tooltipCallout
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].tooltipContent
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _navigationHeader["default"].icon
  }), toolTipMessage), /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].tooltipClose,
    onClick: function onClick() {
      return closeTooltip();
    }
  }));
};
CommonTooltip.defaultProps = {
  toolTipMessage: '',
  timeout: 0,
  isOpen: false,
  delay: 0
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(CommonTooltip);
exports["default"] = _default;